// Award-winning Alt Bollette - New Mock Data

export const soluzioni = [
  {
    id: 1,
    titolo: "Fotovoltaico",
    sottotitolo: "Energia solare su misura",
    descrizione: "Progettiamo impianti fotovoltaici dimensionati sui tuoi consumi reali, con analisi approfondita dell'esposizione, ombreggiamento e obiettivi energetici.",
    icon: "Sun",
    benefici: [
      "Riduzione significativa dei costi in bolletta",
      "Indipendenza dalla rete elettrica",
      "Ritorno dell'investimento in 5-8 anni",
      "Aumento valore immobiliare"
    ],
    image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d"
  },
  {
    id: 2,
    titolo: "Microeolico",
    sottotitolo: "Energia dal vento",
    descrizione: "Turbine eoliche domestiche integrate al fotovoltaico. La produzione annua stimata dipende da ventosità, luogo di installazione e valutazione tecnica specifica.",
    icon: "Wind",
    benefici: [
      "Produzione anche di notte e con cielo coperto",
      "Perfetto complemento al fotovoltaico",
      "Studio di fattibilità anemometrica incluso",
      "Tecnologia silenziosa e compatta"
    ],
    image: "https://images.unsplash.com/photo-1548613053-22087dd8edb8"
  },
  {
    id: 3,
    titolo: "Pompe di Calore",
    sottotitolo: "Climatizzazione efficiente",
    descrizione: "Sistemi di riscaldamento e raffrescamento ad alta efficienza, alimentabili con energia rinnovabile autoprodotta per massimizzare il risparmio.",
    icon: "Thermometer",
    benefici: [
      "Riduzione consumi fino al 70%",
      "Riscaldamento e raffrescamento in un unico sistema",
      "Integrazione con fotovoltaico",
      "Comfort termico ottimale"
    ],
    image: "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2"
  }
];

export const metodoPEP = [
  {
    numero: 1,
    titolo: "Analisi Iniziale",
    descrizione: "Studio approfondito dei consumi, caratteristiche dell'immobile, esposizione, ombreggiamenti e obiettivi del cliente.",
    icon: "ClipboardCheck"
  },
  {
    numero: 2,
    titolo: "Studio di Fattibilità",
    descrizione: "Valutazione tecnica ed economica con simulazioni di produzione energetica e analisi costi-benefici.",
    icon: "LineChart"
  },
  {
    numero: 3,
    titolo: "Progetto Personalizzato",
    descrizione: "Progettazione dell'impianto ottimizzato sulle tue esigenze, con tecnologie selezionate e dimensionamento accurato.",
    icon: "Layers"
  },
  {
    numero: 4,
    titolo: "Installazione Professionale",
    descrizione: "Realizzazione dell'impianto da parte di tecnici certificati, con monitoraggio qualità in ogni fase.",
    icon: "Wrench"
  },
  {
    numero: 5,
    titolo: "Monitoraggio e Assistenza",
    descrizione: "Supporto continuo post-installazione, manutenzione programmata e ottimizzazione delle performance.",
    icon: "Activity"
  }
];

export const percheSceglierci = [
  {
    titolo: "Progetti Realmente Personalizzati",
    descrizione: "Ogni impianto è progettato specificamente per le caratteristiche della tua abitazione e i tuoi obiettivi energetici. Nessuna soluzione standard.",
    icon: "Target"
  },
  {
    titolo: "Studio di Fattibilità Professionale",
    descrizione: "Analisi tecnica approfondita prima di ogni proposta, con simulazioni realistiche e valutazione economica trasparente.",
    icon: "FileCheck"
  },
  {
    titolo: "Tecnologie di Qualità",
    descrizione: "Selezioniamo solo componenti certificati e produttori affidabili, con garanzie estese e supporto post-vendita.",
    icon: "Award"
  },
  {
    titolo: "Assistenza Dedicata",
    descrizione: "Un referente personale ti segue dall'analisi iniziale alla manutenzione, con monitoraggio continuo delle performance.",
    icon: "Headphones"
  },
  {
    titolo: "Trasparenza Totale",
    descrizione: "Costi chiari fin da subito, documentazione completa e comunicazione costante in ogni fase del progetto.",
    icon: "Shield"
  }
];

export const faqData = [
  {
    domanda: "Quanto posso davvero risparmiare con un impianto fotovoltaico?",
    risposta: "Il risparmio dipende da molti fattori: consumo attuale, esposizione del tetto, dimensionamento dell'impianto e presenza di sistemi di accumulo. In media, un impianto ben dimensionato può coprire dal 60% all'80% del fabbisogno energetico annuale. Durante lo studio di fattibilità, forniremo simulazioni specifiche basate sui tuoi consumi reali."
  },
  {
    domanda: "Quanto tempo serve per rientrare dell'investimento?",
    risposta: "Il tempo di rientro varia tipicamente tra 5 e 8 anni, considerando risparmio in bolletta e incentivi disponibili. Dipende da: costo dell'energia, autoconsumo, eventuali detrazioni fiscali e qualità dei componenti. Ogni progetto include un'analisi economica dettagliata con proiezioni a 25 anni."
  },
  {
    domanda: "Il microeolico è adatto alla mia zona?",
    risposta: "La fattibilità del microeolico dipende dalla ventosità media della zona, assenza di ostacoli e normative locali. Prima di ogni proposta, effettuiamo uno studio anemometrico per valutare la producibilità reale. In alcune zone il microeolico può produrre fino al 30% in più rispetto al solo fotovoltaico."
  },
  {
    domanda: "Serve il permesso del Comune per installare i pannelli?",
    risposta: "Nella maggior parte dei casi, l'installazione di pannelli fotovoltaici su tetti esistenti rientra nell'edilizia libera e non richiede permessi particolari. Ci occupiamo noi di verificare vincoli paesaggistici, normative locali e presentare la documentazione necessaria (es. comunicazione al Comune, pratica GSE)."
  },
  {
    domanda: "Cosa succede quando non c'è sole?",
    risposta: "Senza sole, l'impianto fotovoltaico non produce e l'energia viene prelevata dalla rete (o dalle batterie, se presenti). Per questo consigliamo di integrare sistemi di accumulo e, dove possibile, il microeolico che produce anche di notte. L'obiettivo è massimizzare l'autoconsumo e ridurre la dipendenza dalla rete."
  },
  {
    domanda: "Le batterie di accumulo convengono davvero?",
    risposta: "Le batterie permettono di accumulare l'energia prodotta di giorno per usarla la sera/notte, aumentando l'autoconsumo dal 30-40% fino all'80-90%. La convenienza dipende da: profilo di consumo (se consumi molto la sera), costo dell'energia e incentivi disponibili. Nel nostro studio di fattibilità valutiamo sempre l'opzione con e senza accumulo."
  },
  {
    domanda: "Che manutenzione richiede un impianto fotovoltaico?",
    risposta: "La manutenzione è minima: pulizia periodica dei pannelli (1-2 volte l'anno) e controllo dell'inverter. I pannelli hanno garanzie di 25 anni e gli inverter 10-15 anni. Offriamo pacchetti di manutenzione programmata con monitoraggio remoto delle performance per intervenire tempestivamente in caso di anomalie."
  },
  {
    domanda: "Posso installare un impianto se ho un tetto in amianto?",
    risposta: "Sì, anzi è un'ottima occasione per bonificare il tetto e installare i pannelli. Esistono incentivi specifici per la rimozione amianto abbinata all'installazione fotovoltaica. Ci occupiamo dell'intero processo: bonifica certificata, smaltimento e nuova copertura con impianto integrato."
  }
];

export const tipiInteresse = [
  "Fotovoltaico",
  "Microeolico",
  "Pompa di calore",
  "Batterie di accumulo",
  "Consulenza generale"
];

// Encode function for Netlify Forms
export const encode = (data) => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};
